import { OptionType } from '@/components/form/fields/Select/Select';
import { useTableSorting } from '@/components/Table/hooks/useTableSorting';
import { TableSorting } from '@/components/Table/TableSorting/TableSorting';
import { SortingButtonWrapper } from './styles';

type SortingButtonType = {
  option: OptionType | null;
};

export const SortingButton = ({ option }: SortingButtonType) => {
  const { changeSorting, isAscendingSorting, isDescendingSorting, isUnsorted } = useTableSorting(option?.value, true);

  const sorting = () => {
    return changeSorting();
  };

  return (
    <SortingButtonWrapper onClick={sorting} disabled={!option?.value}>
      <TableSorting
        isAscendingSorting={isAscendingSorting}
        isDescendingSorting={isDescendingSorting}
        isUnsorted={isUnsorted}
      />
    </SortingButtonWrapper>
  );
};
